import type { ActionReducerMap } from '@ngrx/store';

import { howToQuestionnaireReducer } from './+state/how-to-questionnaire/how-to-questionnaire.reducer';
import type { CommonUiServiceComponentsState } from './common-ui-service-components-store.interface';

export const reducers: ActionReducerMap<CommonUiServiceComponentsState> = {
  howToQuestionnaire: howToQuestionnaireReducer,
};
